import { Row, Col, Typography, Anchor, Image } from 'antd';
import './styles/Support.css';  // Make sure you are using the correct CSS file
import { useEffect } from 'react';
import ScrollToHash from "../Components/Common/ScrollToHash"; // adjust the path to where you saved it
import showingTheApp from '../images/showing-the-app.jpg';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { Link } = Anchor;



const ReferFriendsMakeMoney = () => {
  
  const location = useLocation();

  return (
    <div className="support-container">

      <Helmet>
          <link rel="canonical" href={`https://punkypay.com${location.pathname}`} />
          <meta name="robots" content="index, follow" />
      </Helmet>
      <ScrollToHash />

      <Row justify="center">
        <Col span={24} md={20} lg={18} xl={16} className="text-center">
          <Title level={1}>Refer Friends, Make Money</Title>
        </Col>
      </Row>


      {/* Support image */}
      <Row justify="center" style={{ marginTop: '20px' }}>
        <Col span={24} md={20} lg={18} xl={16} className="text-center">
          <img src={showingTheApp} className="support-image" alt="support" />
        </Col>
      </Row>

      <Row>
        <Col>
            <Paragraph className="paragraph-custom" >
              Turn your network into earnings with Punkypay. 
              When you refer a friend, you’ll earn <b>50% of the platform fees</b> Punkypay collects from them for the first <b>five years</b> after they sign up. 
            </Paragraph>
            <Paragraph className="paragraph-custom"> 
              <i>Example: Bob refers Alice to Punkypay. 
                Alice then receives money from Carol. 
                Once Alice has received enough funds, Punkypay charges Alice a platform fee, and Bob earns 50% of that fee. 
              </i>
            </Paragraph>
            <Paragraph className="paragraph-custom" >
              <b>It gets even better.</b> 
              When your friend pays someone who hasn’t been referred to Punkypay, you’ll also earn the platform fees generated from that recipient. 
              That means your earning potential can grow beyond just one connection.
            </Paragraph>
            <Paragraph className="paragraph-custom">
              <i>Example: 
                Bob refers Alice to Punkypay. 
                Alice then sends money to Carol. 
                Because Carol was not referred to Punkypay by anyone, Bob earns 50% of the platform fees that Carol pays when receiving money from Alice. 
              </i>
            </Paragraph>
            <Paragraph className="paragraph-custom">
              These fees add up — putting money in your pocket while your friends save money and time. 
            </Paragraph>

        </Col>
      </Row>
    </div>
  );
};

export default ReferFriendsMakeMoney;